<template>
  <div class="about">
    <div>
      <p>Language</p>
      <input id="Json" type="text" v-model="lang" />
    </div>
    <div>
      <p>Assortiment</p>
      <input id="Json" type="text" v-model="SelectedDir" />
    </div>
    <div>
      <input id="Product" type="text" v-model="SelectedJson" />
    </div>
    <div>
      <p>Product Name</p>
      <input id="Product" type="text" v-model="SelectedProduct" />
    </div>
    <button @mouseup="getProductData()">Get</button>
  </div>
  <pre>{{ productText }}</pre>
</template>

<script>
export default {
  data() {
    return {
      SelectedDir: "vinyl",
      SelectedJson: "safe-tex",
      SelectedProduct: "Safe Tex R11",
      lang: "nl",
      productText: "",
    };
  },
  computed: {},
  methods: {
    async getProductData() {
      if (this.SelectedJson !== "") {
        // get Tiles from json
        try {
          const data = await require("@/assets/products/json/" +
            this.lang +
            "/" +
            this.SelectedDir +
            "/" +
            this.SelectedJson);

          let productText = "[";
          let productJson = [];
          let iProduct = 0;

          for (const products in data) {
            if (data[products].naam === this.SelectedProduct) {
              productJson[iProduct] = data[products];
              iProduct++;
            }
          }

          for (const products in productJson) {
            for (const propertie in productJson[products]) {
              // handle values from product object
              let value = '""';

              // if value is an general object
              if (typeof productJson[products][propertie] === "object") {
                // if value is an array
                if (Array.isArray(productJson[products][propertie])) {
                  value = `[${productJson[products][propertie]}]`;
                }
                // if value is object
                else {
                  let valueObject = productJson[products][propertie];
                  for (let valueKey in valueObject) {
                    if (Object.keys(valueObject).length === 1) {
                      value = `{"${valueKey}":"${valueObject[valueKey]}"}`;
                    } else if (
                      Object.keys(valueObject).indexOf(valueKey) === 0
                    ) {
                      value = `{"${valueKey}":"${valueObject[valueKey]}"`;
                    } else if (
                      Object.keys(valueObject).indexOf(valueKey) ===
                      Object.keys(valueObject).length - 1
                    ) {
                      value += `,"${valueKey}":"${valueObject[valueKey]}"}`;
                    } else {
                      value += `,"${valueKey}":"${valueObject[valueKey]}"`;
                    }
                    // end valueObject loop
                  }
                }
              }
              // if value is string
              else if (typeof productJson[products][propertie] === "string") {
                value = `"${productJson[products][propertie]}"`;
              }
              // if value is number
              else if (typeof productJson[products][propertie] === "number") {
                value = Number(productJson[products][propertie]);
              }

              // build product object
              // start of product object
              if (Object.keys(productJson[products]).indexOf(propertie) === 0) {
                productText += `\n{\n"${propertie}":"${value}",\n`;
              }
              // end of product object
              else if (
                Object.keys(productJson[products]).indexOf(propertie) ===
                Object.keys(productJson[products]).length - 1
              ) {
                if (productJson.length - 1 == products) {
                  productText += `"${propertie}":${value}\n}\n`;
                } else {
                  productText += `"${propertie}":${value}\n},\n`;
                }
              }
              // inbetween of product object
              else {
                productText += `"${propertie}":${value},\n`;
              }
              // einde propertie loop
            }
            // einde product loop
          }
          this.productText = productText + "\n]";
        } catch (e) {
          // on error
          this.productText = e;
        }
      }
      // end getProductData
    },
    // end methods
  },
};
</script>
